import React from 'react';
import {SidePopup} from '@tickchak/react-share/app';
import * as css from './AIMessageGenerator.css';
import InnerPop from '../newPopup/innerPop/InnerPop';
import type {TShow} from '../../hooks/useShow';

interface AIMessageGeneratorContainerProps {
    container: 'sidePopup' | 'innerPop';
    show: TShow;
    /** InnerPop closes through the header handler instead of the shared show. */
    innerPopShow: TShow;
    title: string;
    closeOnOutsideClick: boolean;
    hideBackdrop: boolean;
    dataCy: string;
    children: React.ReactNode;
}

/** Wraps the generator panel in the popup shell the caller asked for. */
function AIMessageGeneratorContainer({
    container,
    show,
    innerPopShow,
    title,
    closeOnOutsideClick,
    hideBackdrop,
    dataCy,
    children,
}: AIMessageGeneratorContainerProps) {
    if(container === 'innerPop') {
        return (
            <>
                <css.panelGradientStyles />
                <css.innerPopWrapper
                    onClick={(e) => e.stopPropagation()}
                    onMouseUp={(e) => e.stopPropagation()}
                >
                    <InnerPop show={innerPopShow} title="" dataCy={dataCy} buttons={{}}>
                        {children}
                    </InnerPop>
                </css.innerPopWrapper>
            </>
        );
    }

    return (
        <>
            <css.panelGradientStyles />
            {(hideBackdrop || !closeOnOutsideClick) && (
                <css.aiAgentPanelStyles $hideBackdrop={hideBackdrop} $dataCy={dataCy} />
            )}
            <SidePopup
                show={show}
                panelWidth={css.AI_PANEL_WIDTH}
                ariaLabel={title}
                className={`ai-message-generator-panel ${!closeOnOutsideClick ? 'ai-agent-panel' : ''}`}
                data-cy={dataCy}
            >
                {children}
            </SidePopup>
        </>
    );
}

export default AIMessageGeneratorContainer;
